import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import frontmatter from "remark-frontmatter";
function parseExpressionString(expressionString) {
    return expressionString
        .replace(/^\{\{\s*/, "")
        .replace(/\s*}}$/, "")
        .split(" OR ")
        .map((exprPart) => exprPart.trim())
        .reduce((acc, curr, i, arr) => {
        if (!acc.fallback && /^[A-Z_]{2,}$/.test(curr)) {
            acc.expression.push(curr);
        }
        else {
            acc.fallback += acc.fallback ? " OR " + curr : curr;
        }
        if (i === arr.length - 1 && acc.fallback.length > 0) {
            acc.fallback = acc.fallback.replace(/^"(.*)"$/, "$1");
        }
        return acc;
    }, { expression: [], fallback: "" });
}
function evaluateExpression(exprString, valueMap) {
    const { expression, fallback } = parseExpressionString(exprString);
    return (valueMap[expression.find((varName) => valueMap[varName] !== undefined && valueMap[varName] !== "") || "__undefined"] || fallback);
}
export const LysaDoc = ({ path, variableValues }) => {
    const [mdText, setMdText] = useState("");
    useEffect(() => {
        if (!path) {
            return;
        }
        let isMounted = true;
        fetch(`${process.env.REACT_APP_LYSA_DOCS_URL}/${path}`)
            .then((response) => {
            var _a;
            if (response.ok) {
                if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.startsWith("text/markdown")) {
                    return response.text();
                }
                return "Unfortunately, the document could not be found";
            }
            else {
                return Promise.reject("Failed to fetch markdown document");
            }
        })
            .then((text) => {
            const it = text.matchAll(/\{\{[^}]+}}/g);
            for (let match = it.next(); !match.done; match = it.next()) {
                const expr = match.value[0];
                if (variableValues) {
                    text = text.replace(expr, evaluateExpression(expr, variableValues));
                }
            }
            if (isMounted) {
                setMdText(text);
            }
        })
            .catch((error) => {
            console.error(error);
        });
        return () => {
            isMounted = false;
        };
    }, [path, variableValues]);
    return (React.createElement("div", { className: "lysa-doc" },
        React.createElement(ReactMarkdown, { remarkPlugins: [frontmatter] }, mdText)));
};
